import { render, staticRenderFns } from "./InvestorOnboardingKycProfile.vue?vue&type=template&id=5cf09948&"
import script from "./InvestorOnboardingKycProfile.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingKycProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports